import store from "@/state/store"
import axios from 'axios'

store.subscribe(mutation => {
    switch (mutation.type) {
        case 'auth/SET_TOKEN':
            if (mutation.payload) {
                axios.defaults.headers.common['Authorization'] = `Bearer ${mutation.payload}`
                localStorage.setItem('token', mutation.payload)
            } else {
                axios.defaults.headers.common['Authorization'] = null
                localStorage.removeItem('token')
                localStorage.removeItem('refreshToken')
                localStorage.removeItem('tokenExpiresIn')
                localStorage.removeItem('refreshTokenExpiresIn')
                localStorage.removeItem('totem')
                localStorage.removeItem('empresa')
                localStorage.removeItem('logo')
                localStorage.removeItem('corPadrao')
                localStorage.removeItem('corFonte')
            }
            break;
        case 'auth/SET_TOKEN_PARSED':
            store.dispatch('sessao/setEmpresaTotem')
            break;
    }
})